import React, { useEffect, useState } from 'react'
import IcoBook from '../assets/icons/book'

function easeInOut (t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
}

function smoothScrollTo (targetY, duration = 800) {
  const startY = window.scrollY
  const distance = targetY - startY
  const startTime = performance.now()

  function step (currentTime) {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)
    window.scrollTo(0, startY + distance * easeInOut(progress))
    if (progress < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

function handleAnchorClick (e, hash) {
  e.preventDefault()
  const target = document.querySelector(hash)
  if (target) smoothScrollTo(target.getBoundingClientRect().top + window.scrollY)
}

export default function Header () {
  const [scrolling, setScrolling] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolling(true)
      } else {
        setScrolling(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className={`fixed left-0 top-0 right-0 h-12 items-center flex justify-center px-5 transition-all z-30 text-dark font-semibold ${scrolling ? 'bg-light shadow-md' : 'bg-transparent'}`}>
      <nav className='font-Noto flex justify-between max-w-desktop w-full text-sm lg:text-base'>
        <a href="https://thomasgrenmoor-boutique.sumupstore.com/" target='_blank' className='md:flex hidden items-center gap-x-2.5 hover:shadow-[inset_0_-3px_0_#CA8B21] p-3 rounded-b-sm hover:rounded-b-none bg-light' rel="noreferrer">
          <div className='h-6 w-6'><IcoBook color={'#2d1e25'} /></div>
          <div>Obtenir Le livre</div>
        </a>
        <div className='md:flex hidden'>
          <a href="#page-2" onClick={e => handleAnchorClick(e, '#page-2')} className='hover:shadow-[inset_0_-3px_0_#CA8B21] p-3'>Les Runes Ancestrales</a>
          <a href="#page-4" onClick={e => handleAnchorClick(e, '#page-4')} className='hover:shadow-[inset_0_-3px_0_#CA8B21] p-3'>Thomas Grenmoor</a>
          <a href="#page-5" onClick={e => handleAnchorClick(e, '#page-5')} className='hover:shadow-[inset_0_-3px_0_#CA8B21] p-3'>Progression</a>
          <a href="#page-6" onClick={e => handleAnchorClick(e, '#page-6')} className='hover:shadow-[inset_0_-3px_0_#CA8B21] p-3'>Actualités</a>
          <a href="#page-7" onClick={e => handleAnchorClick(e, '#page-7')} className='hover:shadow-[inset_0_-3px_0_#CA8B21] p-3'>NewsLetter</a>
        </div>
        <h1 className={`text-xl w-full block md:hidden font-Charmonman ${scrolling ? 'text-center font-Noto' : 'text-left'}`}>Thomas Grenmoor</h1>
      </nav>
    </div>
  )
}
